import type { FieldTypeOptions, FieldTypeTemplate, PrimitiveFieldTypeTemplate, RelationFieldTypeTemplate, RelationTypeTemplateResolverContext, ResolvedFieldTypeTemplate } from '#layers/data-model/types/field-types/field-type';
import type { M2MRelationSetupInformation, RelationSetupInformation } from '#layers/data-model/types/field-types/relation-field-setup';
import { callOrReturn } from '#layers/base/public';

const PREFERRED_RELATION_TYPE_ORDER = ['m2o', 'o2m', 'o2o', 'm2m'];

export function isPrimitiveTypeTemplate(type: FieldTypeTemplate): type is PrimitiveFieldTypeTemplate {
	return type.type === 'primitive';
}

export function isRelationTypeTemplate(type: FieldTypeTemplate): type is RelationFieldTypeTemplate {
	return type.type === 'relation';
}

export function getResolvedRelationTypeTemplate<T extends RelationFieldTypeTemplate>(type: T, context: RelationTypeTemplateResolverContext, options?: FieldTypeOptions<T>): ResolvedFieldTypeTemplate<T> {
	return {
		...type,
		supportedRelationTypes: callOrReturn(type.supportedRelationTypes, { options, context }).toSorted((a, b) => PREFERRED_RELATION_TYPE_ORDER.indexOf(a) - PREFERRED_RELATION_TYPE_ORDER.indexOf(b)),
		setupDefaults: callOrReturn(type.setupDefaults, { options, context }),
	} as ResolvedFieldTypeTemplate<T>;
}

export function isM2MRelationSetupInformation(setup: RelationSetupInformation): setup is M2MRelationSetupInformation {
	return 'junction' in setup;
}
